import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConservazioneCaricaDocumentoManualiStep2Component } from './conservazione-carica-documento-manuali-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-manuali-step2', {
            url: '/conservazione-carica-manuali',
            ncyBreadcrumb: {
                label: 'Carica Manuali',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-manuali-step2 flex="100"></conservazione-carica-documento-manuali-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoManualiStep2Module: string = ng
    .module('conservazione-carica-documento-manuali-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoManualiStep2', ConservazioneCaricaDocumentoManualiStep2Component)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-manuali-step2/conservazione-carica-documento-manuali-step2.module.ts